import { Link } from "react-router-dom"
import { formatNumber } from "../../../app/utils/helpers"
import ImageSkeleton from "../../../components/skeletons/ImageSkeleton"
import { ProductCardsSkeleton } from "../../../components/skeletons/ProductCardSkeleton"
import Cookies from "js-cookie"

const ProductCard = ({ product, prefix = "", useTempLink = false }) => {
  const handleClickProduct = () => {
    Cookies.set("productId", product.id)
  }

  return (
    <>
      <article className="">
        <section>
          <div className="h-[170px] sm:h-[330px] lg:h-[350px] w-full object-cover border-2 border-[#dcd6d2] mb-4">
            <Link onClick={handleClickProduct} to={prefix ? `${prefix}/${product?.slug}` : product?.slug}>
              <ImageSkeleton src={product?.photo} alt={product?.name} isDarker custCls="h-full w-full object-cover" />
            </Link>
          </div>
          <div>
            <h1 className="text-[#6e6060] font-agcasmlt text-[18px] sm:text-[23px] lg:text-[27px] leading-[18px] sm:leading-[23px] lg:leading-[27px]">
              <Link onClick={handleClickProduct} to={prefix ? `${prefix}/${product?.slug}` : product?.slug}>{product?.name}</Link></h1>
            <span className="text-[#6e605d] font-agcasmlt font-extralight text-[16px] sm:text-[18px] lg:text-[22px] leading-[16px] sm:leading-[18px] lg:leading-[22px]">IDR {product && formatNumber(product?.price)}</span>
          </div>
        </section>
      </article>
    </>
  )
}

const ProductCards = ({ products, onReq = false, prefix = false, count = 0 }) => {
  return (
    <>
      <div className="w-[90%] lg:w-[80%] mx-auto grid grid-cols-2 lg:grid-cols-3 gap-x-4 sm:gap-x-8 gap-y-8 sm:gap-y-16 pb-16">
        {products.map((p, i) => (
          <div key={i}>
            <ProductCard product={p} prefix={prefix} />
          </div>
        ))}
        {onReq && (
          <ProductCardsSkeleton count={count} />
        )}
      </div>
    </>
  )
}

export {
  ProductCard,
  ProductCards
}